// DEVN3-607: marcação "Revisado" dos grupos da Confirmação de Conciliação (estilo "Viewed" do GitHub).
// É só progresso pessoal de revisão — não altera nada contábil — por isso fica no localStorage do
// navegador, por usuário/esteira/cartão. Cada grupo guarda a assinatura dos IDs dos lançamentos: se a
// composição do grupo mudar (item removido, motor recalculou), a marcação deixa de valer sozinha.

export const REVISADOS_PREFIX = 'conciliacao-revisados:';

/** chaveVinculoMatch → assinatura dos IDs do grupo no momento em que foi marcado. */
export type MapaRevisados = Record<string, string>;

export function chaveRevisados(usuarioId: number | string, esteiraId: number, cartaoId: number): string {
    return `${REVISADOS_PREFIX}${usuarioId}:${esteiraId}:${cartaoId}`;
}

export function assinaturaGrupo(ids: number[]): string {
    return [...ids].sort((a, b) => a - b).join(',');
}

export function lerRevisados(chave: string): MapaRevisados {
    try {
        const json = localStorage.getItem(chave);
        if (!json) return {};
        const mapa = JSON.parse(json);
        return mapa && typeof mapa === 'object' && !Array.isArray(mapa) ? mapa : {};
    } catch {
        return {};
    }
}

export function salvarRevisados(chave: string, mapa: MapaRevisados): void {
    try {
        if (Object.keys(mapa).length === 0) {
            localStorage.removeItem(chave);
        } else {
            localStorage.setItem(chave, JSON.stringify(mapa));
        }
    } catch {
        // storage bloqueado/cheio: a marcação vale só enquanto a modal estiver aberta
    }
}

export function grupoRevisado(mapa: MapaRevisados, chaveVinculoMatch: string, ids: number[]): boolean {
    return mapa[chaveVinculoMatch] === assinaturaGrupo(ids);
}

export function marcarRevisado(mapa: MapaRevisados, chaveVinculoMatch: string, ids: number[]): MapaRevisados {
    return { ...mapa, [chaveVinculoMatch]: assinaturaGrupo(ids) };
}

export function desmarcarRevisado(mapa: MapaRevisados, chaveVinculoMatch: string): MapaRevisados {
    if (!(chaveVinculoMatch in mapa)) return mapa;
    const copia = { ...mapa };
    delete copia[chaveVinculoMatch];
    return copia;
}

/**
 * Descarta marcações de grupos carregados cuja composição mudou. Grupos que não estão em `grupos`
 * são mantidos — a lista é paginada, então ausência não significa que o grupo deixou de existir.
 */
export function descartarRevisadosAlterados(mapa: MapaRevisados, grupos: Record<string, number[]>): MapaRevisados {
    let resultado = mapa;
    Object.keys(grupos).forEach((chave) => {
        if (chave in mapa && !grupoRevisado(mapa, chave, grupos[chave])) {
            resultado = desmarcarRevisado(resultado, chave);
        }
    });
    return resultado;
}
